import { Bone, SkeletonGrid, SkeletonCardTile } from '../primitives';

// Matches Billing.js's real layout: Credits used / Currently on plan summary cards,
// then the plan-cards row (ChooseAPlan). Billing details/payment/invoices now live in
// BillingModal, opened from the "Billing" button, so no skeleton needed for those.
export default function BillingSkeleton() {
    return (
        <div style={{ maxWidth: 780, margin: '0 auto' }}>
            <Bone h={20} w={160} style={{ marginBottom: 6 }} />
            <Bone h={13} w={260} style={{ marginBottom: 20 }} />

            {/* Credits used + Currently on plan cards */}
            <div className="billing-summary-cards" style={{ marginBottom: 16 }}>
                <div style={{ border: '1px solid #E2E8F0', borderRadius: 13, padding: 16 }}>
                    <Bone h={13} w={140} style={{ marginBottom: 10 }} />
                    <Bone h={8} w="100%" r={999} />
                </div>
                <div style={{ border: '1px solid #E2E8F0', borderRadius: 13, padding: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div>
                        <Bone h={12} w={100} style={{ marginBottom: 8 }} />
                        <Bone h={16} w={90} />
                    </div>
                    <Bone h={34} w={80} r={9} />
                </div>
            </div>

            {/* Plan cards */}
            <div style={{ marginBottom: 20 }}>
                <SkeletonGrid cols={3} gap={12}>
                    {Array.from({ length: 3 }).map((_, i) => (
                        <SkeletonCardTile key={i} hasImage={false} lines={3} />
                    ))}
                </SkeletonGrid>
            </div>
        </div>
    );
}
